"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.factory("obsCopyrightPopin", function($modal) {
    return {
        open : function() {
            return $modal.open({
                template: require("./obsCopyrightPopin.html"),
                options: {
                    width: 850
                }
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/presentation/obsCopyrightPopin.js